const FILTER_WIDGET_KEY = "Filter";

export { FILTER_WIDGET_KEY };
